module.exports = __webpack_public_path__ + "static/media/actions.2e98128b.png";